import UIManager from "../../Shared/UIManager"
import NetworkLogic from "../../Shared/NetworkLogic"

const {ccclass, property} = cc._decorator

@ccclass
export default class BalanceDetails extends cc.Component {
    @property(cc.Layout)
    lytContentRecords: cc.Layout = null

    @property(cc.Layout)
    lytContentPayTypes: cc.Layout = null

    @property(cc.Node)
    nodeTemplatePayType: cc.Node = null

    @property(cc.Node)
    nodeTemplateRecord: cc.Node = null

    @property(cc.Node)
    nodeScrollView: cc.Node = null

    @property(cc.Node)
    nodeTimes: cc.Node = null

    @property(cc.Node)
    nodePayTypes: cc.Node = null

    @property(cc.Label)
    lbTime: cc.Label = null

    @property(cc.Label)
    lbPayType: cc.Label = null

    private _startTime = ""
    private _endTime = ""
    private _payType = ""
    
    onLoad () {
        this.nodeTemplatePayType.parent = null
        this.nodeTemplateRecord.parent = null
        this.hideNodeList()
        this.node.parent.parent.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.on(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    start () {
        let date = new Date()
        this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
        this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        this.createPayTypes()
    }

    onDisable () {
        this.hideNodeList()
    }

    onDestroy () {
        this.nodeTemplatePayType.destroy()
        this.nodeTemplateRecord.destroy()
        this.node.parent.parent.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_END, this.hideNodeList, this)
        this.nodeScrollView.off(cc.Node.EventType.TOUCH_CANCEL, this.hideNodeList, this)
    }

    onBtnClick (event, userData) {
        if (userData === "today") {
            this.selectTimeNode(event.target, userData)
        }else if (userData === "yesterday") {
            this.selectTimeNode(event.target, userData)
        }else if (userData === "month") {
            this.selectTimeNode(event.target, userData)
        }else if (userData === "payType") {
            this.selectPayType(event.target["payTypeCfg"])
        }else if (userData === "nodeTimes") {
            this.nodeTimes.active = !this.nodeTimes.active
        }else if (userData === "nodePayTypes") {
            this.nodePayTypes.active = !this.nodePayTypes.active
        }
    }

    hideNodeList () {
        this.nodeTimes.active = false
        this.nodePayTypes.active = false
    }

    private selectTimeNode (node: cc.Node, userData) {
        this.nodeTimes.active = false
        this.lbTime.string = node.getChildByName("name").getComponent(cc.Label).string

        if (userData === "today") {
            let date = new Date()
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        }else if (userData === "yesterday") {
            let date = new Date()
            date.setDate(date.getDate() - 1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = date["format"]("yyyy-MM-dd ") + "23:59:59"
        }else if (userData === "month") {
            let date = new Date()
            date.setDate(1)
            this._startTime = date["format"]("yyyy-M-d ") + "00:00:00"
            this._endTime = (new Date())["format"]("yyyy-MM-dd ") + "23:59:59"
        }
        
        this.queryRecords()
    }

    private selectPayType (payTypeCfg) {
        this.nodePayTypes.active = false
        this.lbPayType.string = payTypeCfg ? payTypeCfg["label"] : "全部"
        this._payType = payTypeCfg ? payTypeCfg["value"] : "all"
        this.queryRecords()
    }

    private createPayTypes () {
        let node = cc.instantiate(this.nodeTemplatePayType)
        node.getChildByName("name").getComponent(cc.Label).string = "全部"
        node.parent = this.lytContentPayTypes.node
        this.selectPayType(undefined)

        NetworkLogic.payTypeList(function (data) {
            data.coinTypeList.forEach(payTypeCfg => {
                let node = cc.instantiate(this.nodeTemplatePayType)
                node.getChildByName("name").getComponent(cc.Label).string = payTypeCfg["label"]
                node["payTypeCfg"] = payTypeCfg
                node.parent = this.lytContentPayTypes.node
            });
        }.bind(this))
    }

    private queryRecords () {
        this.lytContentRecords.node.removeAllChildren()
        this.lytContentRecords.node.destroyAllChildren()

        UIManager.showLoadingUI()
        NetworkLogic.balanceDetailsList(this._startTime, this._endTime, this._payType, function (data) {
            UIManager.hideLoadingUI()
            data.data && data.data.forEach(item => {
                let node = cc.instantiate(this.nodeTemplateRecord)
                node.parent = this.lytContentRecords.node
                node.getChildByName("time").getComponent(cc.Label).string = item.time
                node.getChildByName("type").getComponent(cc.Label).string = item.type
                node.getChildByName("yue").getComponent(cc.Label).string = item.changeBalance
                this.lytContentRecords.node.children.length % 2 === 1 && (node.getChildByName("bg").opacity = 100)

                if (parseFloat(item.money) > 0) {
                    node.getChildByName("money").color = cc.color(80, 192, 255)
                    node.getChildByName("money").getComponent(cc.Label).string = "+" + item.money
                }else {
                    node.getChildByName("money").color = cc.color(190, 74, 74)
                    node.getChildByName("money").getComponent(cc.Label).string = item.money
                }
            });
        }.bind(this))
    }
}